import * as blockrule from './lang/blockrule.json';
import * as category from './lang/category.json';
import * as channel from './lang/channel.json';
import * as consts from './lang/consts.json';
import * as credits from './lang/credits.json';
import * as customer from './lang/customer.json';
import * as dashboard from './lang/dashboard.json';
import * as distribution from './lang/distribution.json';
import * as domain from './lang/domain.json';
import * as extract from './lang/extract.json';
import * as general from './lang/general.json';
import * as integration from './lang/integration.json';
import * as interactions from './lang/interactions.json';
import * as log from './lang/log.json';
import * as login from './lang/login.json';
import * as loop from './lang/loop.json';
import * as metadata from './lang/metadata.json';
import * as milestone from './lang/milestone.json';
import * as notification from './lang/notification.json';
import * as organization from './lang/organization.json';
import * as password from './lang/password.json';
import * as profile from './lang/profile.json';
import * as registration from './lang/registration.json';
import * as report from './lang/report.json';
import * as segment from './lang/segment.json';
import * as sso from './lang/sso.json';
import * as survey from './lang/survey.json';
import * as team from './lang/team.json';
import * as template from './lang/template.json';
import * as unsubscribe from './lang/unsubscribe.json';
import * as user from './lang/user.json';
import * as widget from './lang/widget.json';

export default {
  blockrule: blockrule.default,
  category: category.default,
  channel: channel.default,
  consts: consts.default,
  credits: credits.default,
  customer: customer.default,
  dashboard: dashboard.default,
  distribution: distribution.default,
  domain: domain.default,
  extract: extract.default,
  general: general.default,
  integration: integration.default,
  interactions: interactions.default,
  log: log.default,
  login: login.default,
  loop: loop.default,
  metadata: metadata.default,
  milestone: milestone.default,
  notification: notification.default,
  organization: organization.default,
  password: password.default,
  profile: profile.default,
  registration: registration.default,
  report: report.default,
  segment: segment.default,
  sso: sso.default,
  survey: survey.default,
  team: team.default,
  template: template.default,
  unsubscribe: unsubscribe.default,
  user: user.default,
  widget: widget.default,
};
